import { render, staticRenderFns } from "./outBoundInfo.vue?vue&type=template&id=82835596&scoped=true&"
import script from "./outBoundInfo.vue?vue&type=script&lang=js&"
export * from "./outBoundInfo.vue?vue&type=script&lang=js&"
import style0 from "./outBoundInfo.vue?vue&type=style&index=0&id=82835596&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82835596",
  null
  
)

export default component.exports